import { useEffect, useState } from "react";

import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";

export function useTermsAcknowledgment() {
  const [shouldShowPopup, setShouldShowPopup] = useState(false);

  // Check if user has already acknowledged the terms in localStorage
  const hasAcknowledgedInStorage =
    typeof window !== "undefined"
      ? localStorage.getItem("termsAcknowledged") === "true"
      : false;

  // Get user's contracts to check enrollment dates
  const { data: userContracts, isLoading } = useQuery({
    ...convexQuery(api.partnerships.getPaginatedCreatorPartnershipsForCreator, {
      paginationOpts: { cursor: null, numItems: 100 },
      type: "contracts",
    }),
    enabled: !hasAcknowledgedInStorage, // Only fetch if user hasn't acknowledged yet
  });

  useEffect(() => {
    if (hasAcknowledgedInStorage || isLoading || !userContracts) {
      setShouldShowPopup(false);
      return;
    }

    // Check if user has any contracts created before October 20, 2024
    const october20_2024 = new Date("2024-10-20").getTime();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasEnrolledBeforeOct20 = userContracts.page.some((contract: any) => {
      // Check both _creationTime and startDate
      const creationTime = contract._creationTime;
      const startDate = contract.startDate;

      return (
        (creationTime && creationTime < october20_2024) ||
        (startDate && startDate < october20_2024)
      );
    });

    setShouldShowPopup(hasEnrolledBeforeOct20);
  }, [userContracts, hasAcknowledgedInStorage, isLoading]);

  const markAsAcknowledged = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("termsAcknowledged", "true");
    }
    setShouldShowPopup(false);
  };

  return {
    shouldShowPopup,
    markAsAcknowledged,
    isLoading,
  };
}
